import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';

const Apps = () => {
    return (
        <Container>
            <div className="row py-2">
                <h2>Welcome, Admin</h2>
            </div>
            <div className="row">
                <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                    <Link to="/admin/user/index">
                        <div className="card">
                            <img src="/images/users.png" className="card-img-top" alt="" />
                            <div className="card-body p-1 text-center">
                                <h5 className="card-title mb-0">Users</h5>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                    <Link to="/admin/app/index">
                        <div className="card">
                            <img src="/images/apps.png" className="card-img-top" alt="" />
                            <div className="card-body p-1 text-center">
                                <h5 className="card-title mb-0">Applications</h5>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                    <Link to="/admin/group/index">
                        <div className="card">
                            <img src="/images/privileges.png" className="card-img-top" alt="" />
                            <div className="card-body p-1 text-center">
                                <h5 className="card-title mb-0">Group</h5>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                    <Link to="/admin/documentation/index">
                        <div className="card">
                            <img src="/images/documentation.png" className="card-img-top" alt="" />
                            <div className="card-body p-1 text-center">
                                <h5 className="card-title mb-0">Documentation</h5>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                    <Link to="/admin/projet/index">
                        <div className="card">
                            <img src="/images/projet.png" className="card-img-top" alt="" />
                            <div className="card-body p-1 text-center">
                                <h5 className="card-title mb-0">Projet</h5>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                    <Link to="/admin/fonction/index">
                        <div className="card">
                            <img src="/images/fonction.png" className="card-img-top" alt="" />
                            <div className="card-body p-1 text-center">
                                <h5 className="card-title mb-0">Fonction</h5>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                    <Link to="/admin/event/index">
                        <div className="card">
                            <img src="/images/event.png" className="card-img-top" alt="" />
                            <div className="card-body p-1 text-center">
                                <h5 className="card-title mb-0">Event</h5>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                    <Link to="/admin/hierarchy/graph">
                        <div className="card">
                            <img src="/images/hierarchy.png" className="card-img-top" alt="" />
                            <div className="card-body p-1 text-center">
                                <h5 className="card-title mb-0">Hierarchy</h5>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                    <Link to="/admin/hierarchy/users">
                        <div className="card">
                            <img src="/images/hierarchy-users.png" className="card-img-top" alt="" />
                            <div className="card-body p-1 text-center">
                                <h5 className="card-title mb-0">Users Hierarchy</h5>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                    <Link to="/admin/api-key/index">
                        <div className="card">
                            <img src="/images/api-key.png" className="card-img-top" alt="" />
                            <div className="card-body p-1 text-center">
                                <h5 className="card-title mb-0">Api-Keys</h5>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                    <Link to="/admin/notification/index">
                        <div className="card">
                            <img src="/images/notification.png" className="card-img-top" alt="" />
                            <div className="card-body p-1 text-center">
                                <h5 className="card-title mb-0">Notifications</h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </Container>
    );
};

export default Apps;
